import axios from 'axios';

// Create an instance of axios for Residelly
export default axios.create({
    headers: {
        Authorization: 'Bearer ' + localStorage.getItem('RES_ACCESS'),
    },
});
